import { gql } from 'apollo-boost'

import useMutation, { mutationTypes } from '@utils/graphqlUtils'

const MUTATION = gql`
  mutation(
    $id: String!
  ) {
    deleteOneProvider(
      where: {
        id: $id
      }
    ) {
      id
    }
  }
`

export default () => (
  useMutation(MUTATION, `Fornecedor eliminado`, mutationTypes.DELETE)
)

